/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
const initialState = {
    items: [],
};
export const noticesSlice = createSlice({
    name: 'errorsReducer',
    initialState,
    reducers: {
        addItem: (state, action) => {
            state.items = [...state.items, action.payload];
        },
        addItems: (state, action) => {
            state.items = [...state.items, ...action.payload];
        },
        setItems: (state, action) => {
            console.log('here', action.payload);
            state.items = action.payload;
        },
        removeItem: (state, action) => {
            state.items = [...state.items.filter((item) => item.id !== action.payload)];
        },
        removeItems: (state, action) => {
            state.items = [...state.items.filter((item) => !action.payload.includes(item.id))];
        },
    },
});
export const useNoticesSelectors = useSelector;
export const { addItem, addItems, removeItem, removeItems, setItems, } = noticesSlice.actions;
export default noticesSlice.reducer;
